import { ThemeModeButton } from 'hive-mui-utils';

export function HeaderMenuControls(): JSX.Element {
  return <ThemeModeButton supported={true} />;
}
